import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import AttachIcon from '@wix/da-ds/pkg/Icons/16x16/Attach';
import FavStarIcon from '@wix/da-ds/pkg/Icons/32x32/FavStar';
import DownloadIcon from '@wix/da-ds/pkg/Icons/24x24/Download';
import { DownloadButtonWithCommentPrompt } from '../../../../ActionBar/buttons/DownloadButton';
import BuyPremiumContentButton from './_partials/BuyPremiumContentButton';
import AttachmentsList from './_partials/AttachmentsList/AttachmentsList';
import s from './PcpInfo.scss';
const MIN_VISIBLE_STAT_COUNT = 2;
const PcpInfo = ({ deviation, className })=>{
    var _deviation_extended;
    const { t } = useTranslation();
    if (!deviation.pcp || !((_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.pcp)) {
        return null; // should not get here
    }
    const { salesCount: sales = 0 } = deviation.pcp;
    var _deviation_stats;
    const { favourites = 0 } = (_deviation_stats = deviation.stats) !== null && _deviation_stats !== void 0 ? _deviation_stats : {};
    const { assets = [] } = deviation.extended.pcp;
    const showFavesStat = favourites >= MIN_VISIBLE_STAT_COUNT;
    const showSalesStat = showFavesStat && sales >= MIN_VISIBLE_STAT_COUNT;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['heading']
    }, t('sidebar.pcpInfo.heading.default')), /*#__PURE__*/ React.createElement("div", {
        className: s['pcp-stats']
    }, showFavesStat && /*#__PURE__*/ React.createElement("div", {
        className: s['pcp-stat']
    }, /*#__PURE__*/ React.createElement(FavStarIcon, {
        size: IconSize.SMALLER,
        disableDefaultColors: true
    }), t('sidebar.pcpInfo.stats.favourites', {
        count: favourites
    })), showSalesStat && /*#__PURE__*/ React.createElement("div", {
        className: s['pcp-stat']
    }, /*#__PURE__*/ React.createElement(DownloadIcon, {
        size: IconSize.SMALLER,
        disableDefaultColors: true
    }), t('sidebar.pcpInfo.stats.sold', {
        count: sales
    }))), /*#__PURE__*/ React.createElement(DownloadButtonWithCommentPrompt, {
        className: s['button'],
        deviation: deviation,
        buttonComponent: BuyPremiumContentButton
    }), assets.length > 0 && /*#__PURE__*/ React.createElement("div", {
        className: s['attachments-count']
    }, /*#__PURE__*/ React.createElement(AttachIcon, {
        size: IconSize.SMALLER,
        disableDefaultColors: true
    }), t('sidebar.pcpInfo.attachedFiles', {
        count: assets.length
    })), /*#__PURE__*/ React.createElement(AttachmentsList, {
        assets: assets
    }));
};
PcpInfo.displayName = 'PcpInfo';
export default PcpInfo;
